module.exports = [{"id":1,"icon":"🎩","firstName":"Nick","lastName":"Smet","role":"Full-stack","frameworks":["React","Laravel"]},{"id":2,"icon":"🦉","firstName":"Wim","lastName":"Van Aerschot","role":"Front-end","frameworks":["React","Vue"]}]


//////////////////
// WEBPACK FOOTER
// ./src/data/developers.json
// module id = 156
// module chunks = 0